/** דילמות נוספות (ממוזגות ל־EXTRA_DILEMMAS ב־tapOrSkip.js) — הוסרו כפילויות מול ברירת המחדל */
export const BULK_DILEMMAS = [
  {a: "🍝 פסטה", b: "🍜 ראמן"},
  {a: "🥐 קרואסון", b: "🥯 בייגל"},
  {a: "🧀 גבינה צהובה", b: "🫒 גבינה עיזים"},
  {a: "🍿 פופקורן בקולנוע", b: "🍫 חטיף בקולנוע"},
  {a: "🥗 סלט", b: "🍲 מרק עבה"},
  {a: "🧇 וופל בלגי", b: "🥞 פנקייק אמריקאי"},
  {a: "🍩 דונאט", b: "🧁 קאפקייק"},
  {a: "🥩 סטייק", b: "🐟 דג על הגריל"},
  {a: "🌮 טאקו", b: "🌯 בוריטו"},
  {a: "🍱 בנטו", b: "🍛 קארי"},
  {a: "🍦 גלידה", b: "🥤 מילקשייק"},
  {a: "🫖 תה ירוק", b: "☕ אספרסו כפול"},
  {a: "🍫 ממרח שוקולד", b: "🧀 ממרח גבינה"},
  {a: "🥒 מלפפון חמוץ", b: "🫒 זיתים"},
  {a: "🍋 לימון", b: "🍊 תפוז"},
  {a: "🍉 אבטיח", b: "🍇 ענבים"},
  {a: "🍎 תפוח ירוק", b: "🍎 תפוח אדום"},
  {a: "🎂 עוגת יום הולדת", b: "🍰 עוגת גבינה"},
  {a: "🛋️ ספה רכה", b: "🪑 כיסא ארגונומי"},
  {a: "🪟 חדר עם נוף", b: "🌿 חדר שקט לגמרי"},
  {a: "🔇 שקט מוחלט", b: "🎶 מוזיקה רקע תמיד"},
  {a: "🛏️ מיטה גדולה", b: "🛋️ ספה נוחה"},
  {a: "🚪 דירה קטנה במרכז", b: "🏠 בית גדול בפריפריה"},
  {a: "🏙️ חיים בעיר", b: "🌾 חיים בכפר"},
  {a: "🌲 יער", b: "🏜️ מדבר"},
  {a: "🌊 אוקיינוס", b: "🏞️ אגם הרים"},
  {a: "⛰️ הר", b: "🌾 שדה ירוק"},
  {a: "🎿 סקי", b: "🏄 גלישה"},
  {a: "🧗 טיפוס", b: "🚣 חתירה"},
  {a: "🎯 דיוק", b: "⚡ מהירות"},
  {a: "🐢 איטי ובטוח", b: "🐇 מהר ומסוכן"},
  {a: "📅 תכנון שבוע מראש", b: "🎲 ספונטני בכל יום"},
  {a: "⏱️ יום עמוס אחד", b: "🦥 שבוע ריקוע"},
  {a: "📦 ארגון מושלם", b: "🎨 יצירתיות בלתי צפויה"},
  {a: "🧩 פאזל 1000 חלקים", b: "🎮 משחק וידאו מהיר"},
  {a: "♟️ שחמט", b: "🃏 קלפים"},
  {a: "🎲 משחק קופסה עם חברים", b: "📱 משחק אונליין לבד"},
  {a: "🏆 לנצח תמיד", b: "🤝 ליהנות גם כשמפסידים"},
  {a: "🥇 מקום ראשון", b: "🎭 חוויה בלתי נשכחת"},
  {a: "📸 פוטו מושלם", b: "👁️ רגע אמיתי"},
  {a: "✨ פילטרים", b: "🪞 בלי פילטר"},
  {a: "📖 פיד ארוך", b: "📌 סטורי קצר"},
  {a: "🔔 התראות פעילות", b: "🔕 מצב שקט"},
  {a: "💬 צ׳אט קבוצתי סוער", b: "📞 שיחה אחת על אחד"},
  {a: "🎥 זום עם וידאו", b: "📞 שיחה קולית בלבד"},
  {a: "📧 אימייל מסודר", b: "💬 וואטסאפ מהיר"},
  {a: "🧹 חדר מסודר", b: "🤷 איפה שהשמת"},
  {a: "🤳 זיהוי פנים", b: "👆 זיהוי אצבע"},
  {a: "🖥️ מסך גדול ", b: "💻 לפטופ קטן "},
  {a: "⌨️ מקלדת מכנית", b: "⌨️ מקלדת שקטה"},
  {a: "🖱️ עכבר גיימינג", b: "🖐️ טראקפד"},
  {a: "🎧 אוזניות עם ביטול רעש", b: "🔊 רמקולים"},
  {a: "📱 מסך קטן", b: "📲 טאבלט גדול"},
  {a: "🔋 סוללה ליום שלם", b: "⚡ טעינה מהירה"},
  {a: "🌐 אינטרנט מהיר בבית", b: "📡 אינטרנט יציב בחוץ"},
  {a: "🎬 סדרה אחת עד הסוף", b: "🎞️ עשרה סרטים שונים"},
  {a: "📺 בינג׳ לילה", b: "📅 פרק אחד ביום"},
  {a: "🍿 סרט עם פופקורן", b: "🍕 סרט עם פיצה"},
  {a: "😱 סרט מתח", b: "😂 קומדיה רומנטית"},
  {a: "🕵️ מיסתורין", b: "🚀 מדע בדיוני"},
  {a: "📚 ספרת עיון", b: "📕 רומן"},
  {a: "✍️ לכתוב יומן", b: "🎨 לצייר סקיצה"},
  {a: "🎹 לנגן כלי", b: "🎧 רק להאזין"},
  {a: "🎼 מוזיקה קלאסית", b: "🥁 מוזיקה אלקטרונית"},
  {a: "🎤 ראפ", b: "🎸 רוק"},
  {a: "🏟️ אצטדיון מלא", b: "🎸 הופעה אינטימית"},
  {a: "🎤 קריוקי עם חברים", b: "🎧 הקשבה שקטה לאלבום"},
  {a: "📻 פודקאסט על היסטוריה", b: "📻 פודקאסט על מדע"},
  {a: "🧪 ניסוי במעבדה", b: "🔭 תצפית בשמיים"},
  {a: "🦕 דינוזאורים", b: "🚀 חלל"},
  {a: "🧬 ביולוגיה", b: "⚛️ פיזיקה"},
  {a: "🗣️ לדבר חמש שפות ברמה בינונית", b: "🗣️ לדבר שפה אחת כמו דובר שפת אם"},
  {a: "📜 לדעת היסטוריה", b: "🌍 לדעת גיאוגרפיה"},
  {a: "🧮 מתמטיקה מהירה", b: "📖 הבנת טקסטים ארוכים"},
  {a: "🎨 כישרון ציור", b: "✍️ כישרון כתיבה"},
  {a: "🎭 משחק בתיאטרון", b: "🎬 משחק בקולנוע"},
  {a: "🕺 ריקוד סלסה", b: "🩰 בלט"},
  {a: "🤸 אקרובטיקה", b: "🥋 אומנויות לחימה"},
  {a: "🏋️ חדר כושר", b: "🏃 ריצה בחוץ"},
  {a: "🧘 יוגה", b: "🥊 אגרוף"},
  {a: "🏊 בריכה מקורה", b: "🌊 ים פתוח"},
  {a: "🎿 שלג טרי", b: "🏖️ חול חם"},
  {a: "🌧️ ריצה בגשם", b: "☀️ ריצה בשמש"},
  {a: "🌙 לילה שקט", b: "🌅 בוקר מוקדם"},
  {a: "🦉 ינשוף", b: "🐓 ערני בוקר"},
  {a: "🍳 ארוחת בוקר", b: "☕ רק קפה"},
  {a: "🍽️ מסעדה יוקרתית כל בחודש", b: "🍔 פאסט פוד כל בשבוע"},
  {a: "🌍 מטבח שף", b: "🏠 מטבח סבתא"},
  {a: "🌶️ מאכל חדש כל שבוע", b: "🍽️ אותו קלאסיק תמיד"},
  {a: "🥡 משלוח מהיר", b: "🚶 לאסוף מהמסעדה"},
  {a: "🧊 שתייה קרה", b: "☕ משקה חם"},
  {a: "🍵 צ׳אי מתובל", b: "🫖 תה שחור פשוט"},
  {a: "🧃 סמוזי", b: "🥤 שייק חלבון"},
  {a: "🍦 גלידה איטלקית", b: "🍧 גרניטה"},
  {a: "🎂 עוגה בבית", b: "🧁 קינוח במסעדה"},
  {a: "🍪 עוגיות חמות", b: "🍩 דונאט מקופסה"},
  {a: "🐕 כלב גדול", b: "🐈 חתול קטן"},
  {a: "🦜 תוכי מדבר", b: "🐠 אקווריום שקט"},
  {a: "🐢 צב ארוך חיים", b: "🐹 אוגר חמוד"},
  {a: "🌳 גינה עם עצים", b: "🌻 גינה עם פרחים"},
  {a: "🪴 צמח אחד מושלם", b: "🌿 ג׳ונגל בבית"},
  {a: "☀️ אור טבעי", b: "💡 תאורה חכמה"},
  {a: "🕯️ נרות ריחניים", b: "🌬️ מפיץ ריח אלקטרוני"},
  {a: "🧼 ניקיון שבועי", b: "🧹 ניקיון עמוק פעם בחודש"},
  {a: "🧺 כביסה מסודרת", b: "👕 קניית בגדים חדשים"},
  {a: "👔 בגדי חג", b: "👕 סווטשירט"},
  {a: "👗 אופנה עכשווית", b: "🕰️ וינטג׳ קלאסי"},
  {a: "🧢 כובע בייסבול", b: "🎩 כובע צמר"},
  {a: "🕶️ משקפי שמש גדולים", b: "👓 משקפי ראייה אופנתיים"},
  {a: "💍 תכשיט עדין", b: "⌚ שעון חכם"},
  {a: "🎒 תיק גב", b: "👜 תיק צד"},
  {a: "🚗 נהיגה עצמית", b: "🚇 תחבורה ציבורית"},
  {a: "🛵 קטנוע בעיר", b: "🚲 אופניים חשמליים"},
  {a: "✈️ טיסה ישירה ארוכה", b: "🚂 רכבת עם עצירות"},
  {a: "🧳 מזוודה אחת קלה", b: "🎒 שלושה תיקים מלאים"},
  {a: "🏨 מלון במרכז", b: "🏡 אירוח מקומי"},
  {a: "🗼 טוקיו", b: "🗽 ניו יורק"},
  {a: "🏛️ רומא", b: "🌉 לונדון"},
  {a: "🏜️ מרוקו", b: "🌴 תאילנד"},
  {a: "❄️ איסלנד", b: "🌺 הוואי"},
  {a: "🎒 טיול תרמילאים זול", b: "🥂 חופשה יוקרתית קצרה"},
  {a: "📷 מצלמה מקצועית", b: "📱 סמארטפון עם מצלמה טובה"},
  {a: "🖼️ אלבום מודפס", b: "☁️ ענן תמונות אינסופי"},
  {a: "🎥 ולוג יומי", b: "📸 תמונה אחת ביום"},
  {a: "🌟 להיות מפורסם", b: "🔒 פרטיות מוחלטת"},
  {a: "🤝 הרבה חברים", b: "💎 כמה חברים קרובים מאוד"},
  {a: "🎉 מסיבה גדולה", b: "🍽️ ארוחת ערב קטנה"},
  {a: "💃 ריקודים עד הבוקר", b: "🛋️ שיחה עמוקה על הספה"},
  {a: "🎁 מתנה מושלמת אחת", b: "🎀 הרבה מתנות קטנות"},
  {a: "📝 כרטיס ברכה ארוך", b: "🤗 חיבוק חזק"},
  {a: "🎂 יום הולדת מפואר", b: "🌄 טיול יום אינטימי"},
  {a: "🎄 חג משפחתי מסורתי", b: "✈️ חג בחו״ל"},
  {a: "🕎 חנוכה", b: "🎆 ראש השנה האזרחי"},
  {a: "🎃 האלווין", b: "🎭 פורים"},
  {a: "💐 זר פרחים", b: "🪴 עציץ"},
  {a: "📜 מכתב מרגש", b: "💌 מייל מרגש"},
  {a: "🗣️ להגיד את האמת ישר", b: "🎀 לנסח בעדינות"},
  {a: "🧊 קור רוח בתקרית", b: "❤️‍🔥 תגובה רגשית כנה"},
  {a: "🎯 מטרה אחת גדולה", b: "📋 עשר מטרות קטנות"},
];
